import { ShortcutHandler as ShortcutHandlerComponent } from './ShortcutHandler.component';
import { connector } from './ShortcutHandler.connector';

export const ShortcutHandler = connector(ShortcutHandlerComponent);
